<cosmos-auth-layout
  [title]="'auth.verifyEmail.title' | translate"
  [subtitle]="'auth.verifyEmail.subtitle' | translate"
>

  <div class="d-flex flex-column">
      <p class="my-3">{{ validateText() }}</p>
      @if (error()) {
        <!-- button to redirect to 'validate' page -->
        <button pButton class="w-full mb-4"  [outlined]="true" routerLink="/validate">
          {{'signup.back-to-validate' | translate}}
        </button>

      }
      <button pButton [disabled]="validating() || error()" class="w-full"  color="primary" routerLink="/validate">{{'signup.back-to-login' | translate}}</button>
  </div>

</cosmos-auth-layout>
